import { render, staticRenderFns } from "./ItemFerramentaEstudo.vue?vue&type=template&id=52afacfd&scoped=true"
import script from "./ItemFerramentaEstudo.vue?vue&type=script&lang=js"
export * from "./ItemFerramentaEstudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52afacfd",
  null
  
)

export default component.exports